import { Edit } from "react-admin";
import { useLocation } from "react-router-dom";
import { CLASSES, StudentServicePath } from "utils/constants";
import BackButtonToolbar from "features/BackButtonToolbar";
import StudentCheckboxForm from "./StudentCheckboxForm";

const UpdateClassesStudentPresence = () => {
  // Reached from the regular classes list and from the preparatory one; returnTo lets the caller decide
  // where saving lands.
  const { state } = useLocation();

  return (
    <Edit
      redirect={state?.returnTo ?? `/${StudentServicePath}${CLASSES}`}
      title="Присъствие на студенти"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <StudentCheckboxForm />
    </Edit>
  );
};

export default UpdateClassesStudentPresence;
